module.exports = __webpack_public_path__ + "img/7.b8867f8e.png";